import { render, staticRenderFns } from "./RecentArticles.vue?vue&type=template&id=f9abb530&scoped=true"
import script from "./RecentArticles.vue?vue&type=script&lang=js"
export * from "./RecentArticles.vue?vue&type=script&lang=js"
import style0 from "./RecentArticles.vue?vue&type=style&index=0&id=f9abb530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9abb530",
  null
  
)

export default component.exports